/**
 * Voltar dentro do app — para o PWA instalado no iPhone, que NÃO tem botão
 * voltar do navegador (Arena Figueira usa o CRM só assim, 22/10/2026). Sem
 * isto, toda navegação de uma tela para outra (ficha → aula, oportunidade →
 * WhatsApp, aulas → chamada na agenda, dashboard → experimentais, Minha conta)
 * vira beco sem saída: a única saída é o menu, e o contexto se perde.
 *
 * O react-router (BrowserRouter, v6) grava em `history.state.idx` a posição da
 * entrada na pilha DESTA aba: 0 é a primeira tela aberta. Só há para onde
 * voltar dentro do app com idx > 0 — assim o botão nunca leva para fora do CRM
 * (ex.: a página de onde o link veio) nem some no meio do caminho.
 */
export function podeVoltarNoApp(historyState: unknown): boolean {
  if (!historyState || typeof historyState !== "object") return false;
  const idx = (historyState as { idx?: unknown }).idx;
  return typeof idx === "number" && Number.isFinite(idx) && idx > 0;
}

/** PWA instalado (tela inicial do iPhone/Android): sem barra nem voltar do navegador. */
export function estaInstaladoComoApp(): boolean {
  if (typeof window === "undefined") return false;
  const iosStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  const displayStandalone =
    typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches;
  return iosStandalone || displayStandalone;
}
